import { IDs } from '../../helpers/IDs';
import parse from 'html-react-parser';
import * as React from 'react';
import style from './Förderung.less';
import { WArchivImage } from '../../core/elements/WArchivImage';

interface FoerderungProps extends React.ClassAttributes<any> {
    data: any;
}

export class Foerderung extends React.Component<FoerderungProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.getRegionaleFoerderung = this.getRegionaleFoerderung.bind(this);
        this.renderFoerderungen = this.renderFoerderungen.bind(this);
    }

    getRegionaleFoerderung(): any {
        let bundesland_tid: number = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])
            .find((param: any) => param.bundesland_orig) || {}).bundesland_orig || null;
        if (!bundesland_tid) {
            bundesland_tid  = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])
            .find((param: any) => param.bundesland) || {}).bundesland || null;
        }
        const bundesland: any = (this.props.data[IDs.ENT_BUNDESLAND] || [])
            .find((param: any) => (param.tid || null) === bundesland_tid) || {};


        console.log('Bundesland: ', bundesland_tid, bundesland, this.props.data[IDs.ENT_UNTERNEHMENSDATEN] ,  this.props.data[IDs.ENT_BUNDESLAND]);
        return Object.keys(bundesland).length > 0
            ?
            {
                name: bundesland.foerderung_text || null,
                logo: bundesland.foerderung_logo || null,
                link: bundesland.foerderung_link || null
            }
            : {};
    }

    render(): JSX.Element {
        return (
            <div style={{ flexDirection: 'row', display: 'flex', flex: 1 }}>
                <div className={style.kacheln}>
                    {this.renderFoerderungen()}
                </div>
            </div>
        );
    }

    renderFoerderungen(): JSX.Element {
        const bereich_key: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        const whitelist: Array<any> = [];
        const regulated: any = {};

        (this.props.data[IDs.ENT_FOERDERUNG_ZUORDNUNG] || []).forEach((item: any) => {
            if ((item.bereich_key_orig || item.bereich_key) === bereich_key && item.foerderung) {
                whitelist.push(item.foerderung_orig);
            }
            regulated[item.foerderung_orig] = true;
        });
        const data: Array<any> = (this.props.data[IDs.ENT_FOERDERUNG] || [])
            .filter((item: any) => !regulated[item.tid] || whitelist.indexOf(item.tid) !== -1);
        const dataRegional: any = this.getRegionaleFoerderung() || {};
        const foerderungen: Array<JSX.Element> = [];
        let link: string;
        let logo: number;
        let text: string;
        let modul: string;

       // console.log('Foerderung', regulated, whitelist, data, this.props.data[IDs.ENT_FOERDERUNG]);


        data.forEach((foerderung: any, index: number) => {
            if ((foerderung.name || null) === 'Landesförderung' && Object.keys(dataRegional).length) {
                link = dataRegional.link || null;
                logo = dataRegional.logo || null;
                text = foerderung.text || null;
                modul = IDs.MOD_ETOOL_ADMIN;
            } else {
                link = foerderung.link || null;
                logo = foerderung.logo || null;
                text = foerderung.text || null;
                modul = IDs.MOD_ETOOL_ADMIN;
            }
            foerderungen.push(
                <a
                    key={`foerderung-${index}`}
                    href={link || '#'}
                    target={link ? '_blank' : null}
                >
                    <div>
                        <WArchivImage modul={modul} archivId={logo} />
                        <div>{parse(text || '')}</div>
                    </div>
                </a>
            );
        });
        return <div>{foerderungen}</div>;
    }
}
